import { buildHeadersWithWidgetToken } from '@elfsight/lib-utils';

const API_URL = 'https://storage.elfsight.com/';

type Request = {
  endpoint: string;
  widgetToken: string | undefined;
  params?: Record<string, string>;
  options?: Record<string, string>;
};

export type ForecastListItem = {
  dt: number;
  main: {
    temp: number;
    feels_like: number;
    temp_min: number;
    temp_max: number;
    pressure: number;
    sea_level: number;
    grnd_level: number;
    humidity: number;
    temp_kf: number;
  };
  weather: {
    id: number;
    main: string;
    description: string;
    icon: string;
  }[];
  clouds: {
    all: number;
  };
  wind: {
    speed: number;
    deg: number;
    gust: number;
  };
  visibility: number;
  pop: number;
  sys: {
    pod: string;
  };
  dt_txt: string;
};

export type ForecastDailyListItem = {
  dt: number;
  sunrise: number;
  sunset: number;
  temp: {
    day: number;
    min: number;
    max: number;
    night: number;
    eve: number;
    morn: number;
  };
  feels_like: {
    day: number;
    night: number;
    eve: number;
    morn: number;
  };
  pressure: number;
  humidity: number;
  weather: [
    {
      id: number;
      main: string;
      description: string;
      icon: string;
    }
  ];
  speed: number;
  deg: number;
  gust: number;
  clouds: number;
  pop: number;
};

export type RequestResponse<T> = {
  city: {
    id: number;
    name: string;
    coord: {
      lon: number;
      lat: number;
    };
    sunrise: number;
    sunset: number;
    country: string;
    population: number;
    timezone: number;
  };
  cod: number;
  message: number;
  cnt: number;
  list: T[];
};

export const request = async <T>({
  endpoint,
  widgetToken,
  params = {},
  options = {}
}: Request): Promise<RequestResponse<T>> => {
  const normalizedApiUrl = API_URL.replace(/\/+$/, '');

  const searchParams = new URLSearchParams(
    Object.assign(
      {
        q: `${endpoint}`
      },
      params
    )
  );

  const response = await fetch(
    `${normalizedApiUrl}/api/v2/weather?${searchParams}`,
    {
      headers: buildHeadersWithWidgetToken(widgetToken),
      mode: 'cors',
      ...options
    }
  );

  return await response.json();
};
